import { makeStyles, createTheme } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  paper: {
    width: ({ isDesktop }) => (!isDesktop ? "70%" : "50%"),
    [theme.breakpoints.up("sm")]: {
      width: "40%",
    },
    maxWidth: 500,
  },
  alertLeft: {
    display: "inline-flex !important",
    right: 4,
  },
  progress: {
    marginLeft: 10,
  },
}));

export const getMuiTheme = ({ isGrid }) =>
  createTheme({
    overrides: {
      MUIDataTableBodyCell: {
        root: {
          padding: "4px 10px",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          // eslint-disable-next-line no-useless-computed-key
          ["@media(min-width: 960px)"]: {
            maxWidth: 200,
          },
        },
      },
      MUIDataTableToolbar: {
        root: {
          background:
            "linear-gradient(125deg, rgba(17, 151, 192, 1) 25%, rgba(4, 7, 25, 1) 100%)",
          minHeight: "50px",
          height: "50px",
          borderTopLeftRadius: "3px",
          borderTopRightRadius: "3px",
          color: "white",
        },
        icon: {
          color: "white",
        },
        titleRoot: {
          display: "none",
        },
        left: {
          marginLeft: 80,
        },
      },
      MUIDataTable: {
        root: {
          display: !isGrid ? "block" : "none",
        },
      },
      MuiTable: {
        root: {
          display: !isGrid ? "table" : "none",
        },
      },
      MUIDataTableHeadCell: {
        fixedHeader: {
          zIndex: 90,
        },
      },
    },
  });
